export function claimableFees(offers,requests,member,now=new Date()){
  return offers.filter(o=>o.active&&o.credit_eligible&&o.open_for_credit!==false&&new Date(o.claim_deadline)>now
    &&!o.unavailable_for?.includes(member.member_id)
    &&!requests.some(r=>r.member_id===member.member_id&&r.offer_id===o.id&&['requested','approved','used'].includes(r.status)))
}
